const survey = '/surveys';
export const createSurvey = survey;
export const getSurveys = survey;
export const getSurveyById = (id: number) => `${survey}/${id}`;
export const updateSurvey = (id: number) => `${survey}/${id}`;
export const getSurveyReport = (id: number) => `${survey}/${id}/report`;
